'use strict';

export const Constants = Object.freeze({
  MANAGE_SURVEY_TABS: [
    {
      key: 'QUOTAS',
      title: 'QUOTAS',
      active: true,
    },
    {
      key: 'AUDIENCE',
      title: 'AUDIENCE',
      active: false,
    },
    {
      key: 'SUPPLIERS',
      title: 'SUPPLIERS',
      active: false,
    },
    {
      key: 'REPORTS',
      title: 'REPORTS',
      active: false,
    },
    {
      key: 'LINK_OTHER_DETAILS',
      title: 'LINK/OTHER DETAILS',
      active: false,
    },
    {
      key: 'RECONCILE',
      title: 'RECONCILE',
      active: false,
    },
    {
      key: 'ACTIVITY_LOGS',
      title: 'ACTIVITY LOGS',
      active: false,
    },
    {
      key: 'TRAFFIC_CHANNELS',
      title: 'TRAFFIC CHANNELS',
      active: false,
    },
    {
      key: 'MULTI_COUNTRY',
      title: 'MULTI-COUNTRY',
      active: false,
      className: 'multi-country',
    },
    {
      key: 'MARGIN_MAX',
      title: 'Margin Max',
      active: false,
    },
    {
      key: 'HEALTH_CHECKS',
      title: 'HEALTH CHECKS',
      active: false,
    },
  ],
  SURVEY_SUPPLIER_TAB_KEY: [
    'QUOTAS',
    'AUDIENCE',
    'LINK_OTHER_DETAILS',
    'REPORTS',
  ],
  MC_QB: {
    SELECTED_LOCALE_TEXT:
      'You are viewing information only for #COUNTRY# in #LANGUAGE#',
    ALL_LOCALE_TEXT: 'You are viewing information for all locales',
    DYANAMIC_TABS: [
      'AUDIENCE',
      'QUOTAS',
      'SUPPLIERS',
      'ACTIVITY_LOGS',
      'TRAFFIC_CHANNELS',
      'MARGIN_MAX',
      'HEALTH_CHECKS',
    ],
    DYNAMIC_TAB_SPECIAL_SYMBOL: '\u2022',
  },
});
